module.exports = "/assets/data/8b54986783ce927d80a93209e9b2bfe4-LS7.data.json";